import React from "react";
import { TableRow, TableCell, Button, Box } from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { useSelector } from "react-redux";

import theme from "../../../theme/theme";
import { formatDate } from "../../../utils/formateDate";

import MeetingTitle from "../../Meeting/MeetingTitle";
import MeetingCompanyName from "../../Meeting/MeetingCompanyName";
import MeetingOrganizer from "../../Meeting/MeetingOrganizer";
import MeetingDescription from "../../Meeting/MeetingDescription";
import MeetingStatusBadge from "../../Meeting/MeetingStatusBadge";
import MeetingConflictBadge from "../../Meeting/MeetingConflictBadge";

const MeetingBox = ({ meeting, openMeetingModal }) => {
  const user = useSelector((state) => state.auth.user);

  return (
    <TableRow
      sx={{
        width: "100%",
        backgroundColor: "#fff",
        transition: "all .2s ease",

        borderLeft:
          user?.id === meeting.ownerId
            ? `6px solid ${theme.palette.primary.main}`
            : "6px solid transparent",

        "&:hover": {
          backgroundColor: "rgb(172 210 240 / 20%)",
        },

        "& td": {
          fontSize: 14,
          color: "#222",
          verticalAlign: "middle",
          py: { xs: 1.5, md: 2 },
          px: { xs: 1, md: 2 },
          borderBottom: "1px solid #e6e9ef",
          borderRight: "1px solid #f0f2f6",
          overflow: "hidden",
          textOverflow: "ellipsis",
        },

        "& td:last-of-type": {
          borderRight: "none",
        },
      }}
    >
    <TableCell
  align="center"
  sx={{
    display: { xs: "none", md: "table-cell" },
    fontWeight: 500,
    color: "#555",
  }}
>
  {meeting.id}
</TableCell>
      <TableCell
      
        sx={{
          width: { xs: "auto", md: 180 },
          fontWeight: 600,
          whiteSpace: "normal",
        textAlign:{xs:"left",md:"center"}
        }}
      >
        <MeetingTitle title={meeting.title} />

      
        <Box sx={{ display: { xs: "block", md: "none" }, mt: 1 }}>
          <details>
            <summary
              style={{
                cursor: "pointer",
                color: theme.palette.primary.main,
                fontWeight: 500,
              }}
            >
              View details
            </summary>

            <Box sx={{ mt: 1, fontSize: 14, color: "#555" }}>
              <div style={{ marginBottom: "6px",fontWeight:"400" }}>
  <strong>Meeting ID:</strong> {meeting.id}
</div>
              <div style={{ marginBottom: "6px" ,fontWeight:"400"}}>
                <strong>Date:</strong>{" "}
                {formatDate(meeting.startDate, meeting.endDate)}
              </div>

              <div style={{ marginBottom: "6px", display: "flex", alignItems: "center", gap: "6px", flexWrap: "wrap" }}>
                <strong>Status:</strong>{" "}
                <MeetingStatusBadge meeting={meeting} userId={user?.id} />
                <MeetingConflictBadge meeting={meeting} />
              </div>

              <div style={{ marginBottom: "6px" }}>
                <strong>Company:</strong>{" "}
                <MeetingCompanyName company={meeting.owner.company.name} />
              </div>

              <div style={{ marginBottom: "6px" }}>
                <strong>Meeting Organizer:</strong>{" "}
                <MeetingOrganizer
                  organizer={`${meeting.owner.firstName} ${meeting.owner.lastName} - (${meeting.owner.company.name}) - (${meeting.owner.position})`}
                  user={user}
                  meeting={meeting}
                />
              </div >

              <div style={{ marginBottom: "6px" }}>
                <strong>Description:</strong>{" "}
                <MeetingDescription description={meeting.description} />
              </div>

              <Button
                fullWidth
                sx={{ mt: 1 }}
                variant="outlined"
                onClick={() => openMeetingModal(meeting.id)}
              >
                Show Details
              </Button>
            </Box>
          </details>
        </Box>
      </TableCell>

    
      <TableCell
        align="center"
        sx={{ display: { xs: "none", md: "table-cell" } }}
      >
        {formatDate(meeting.startDate, meeting.endDate)}
      </TableCell>

      <TableCell
        align="center"
        sx={{ display: { xs: "none", md: "table-cell" } }}
      >
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 4 }}>
          <MeetingStatusBadge meeting={meeting} userId={user?.id} />
          <MeetingConflictBadge meeting={meeting} />
        </div>
      </TableCell>

      <TableCell
        align="center"
        sx={{ display: { xs: "none", md: "table-cell" } }}
      >
        <MeetingCompanyName company={meeting.owner.company.name} />
      </TableCell>

      <TableCell
        sx={{ display: { xs: "none", md: "table-cell" },textAlign:{xs:"left",md:"center"} }}
      >
        <MeetingOrganizer
          organizer={`${meeting.owner.firstName} ${meeting.owner.lastName} - (${meeting.owner.company.name}) - (${meeting.owner.position})`}
          user={user}
          meeting={meeting}
        />
      </TableCell>

      <TableCell
       align="center"
        sx={{
          minWidth: { md: 300 },
          maxWidth: { md: 420 },
          lineHeight: 1.6,
          color: "#555",
          display: { xs: "none", md: "table-cell" },
        }}
      >
        <MeetingDescription description={meeting.description ?? ""} />
      </TableCell>

      <TableCell
        align="center"
        sx={{ width: { xs: 140, md: 180 }, display: { xs: "none", md: "table-cell" } }}
      >
        <Button
          variant="outlined"
          endIcon={<ChevronRightIcon />}
          onClick={() => openMeetingModal(meeting.id)}
          sx={{
            fontSize: 13,
            fontWeight: 500,
            color: theme.palette.primary.main,
            borderColor: theme.palette.primary.main,
            textTransform: "capitalize",
            borderRadius: "6px",
            px: { xs: 1.5, md: 2.5 },

            "&:hover": {
              backgroundColor: theme.palette.primary.main,
              color: "#fff",
              boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
            },
          }}
        >
          Show Details
        </Button>
      </TableCell>
    </TableRow>
  );
};

export default MeetingBox;
